import { invariant } from '@veraclins-dev/utils';
import { useRouteLoaderData } from 'react-router';

import { type RequestInfo } from './types';

/**
 * @returns the request info from the root loader
 */
export function useRequestInfo<T extends { requestInfo: RequestInfo }>(
  routeId = 'root',
): T['requestInfo'] {
  const data = useRouteLoaderData<T>(routeId);
  invariant(data?.requestInfo, 'No requestInfo found in root loader');

  return data.requestInfo;
}
